<ion-content>
  <div class="py-4">
    @for (d of welticoColors; track d) {
      <div class="px-4 mb-3">
        <ion-label class="color-medium text-uppercase fw-bold">{{
          d.title | translate
        }}</ion-label>
      </div>

      @for (colors of d.colors; track colors; let index = $index) {
        <div class="px-4">
          <div class="row mb-3">
            @for (c of colors; track c) {
              <div class="col">
                @if (!c.code) {
                  <div></div>
                } @else {
                  <div
                    class="pointer-hover p-2 color-selection-container"
                    (click)="selectColor(c.code)"
                    [class.color-selection-container-select]="
                      this.value === c.code
                    "
                  >
                    <div class="text-center">
                      @if (c.type === 'rectangle') {
                        @if (c.image) {
                          <div
                            class="d-inline-block sequence-indicator sequence-indicator-wide"
                            [style.background-image]="'url(' + c.image + ')'"
                          ></div>
                        } @else {
                          <div
                            class="d-inline-block sequence-indicator sequence-indicator-wide"
                            [style.background-color]="c.color"
                          ></div>
                        }
                      } @else if (c.type === 'round') {
                        @if (c.image) {
                          <div
                            class="d-inline-block color-indicator"
                            [style.background-image]="'url(' + c.image + ')'"
                          ></div>
                        } @else {
                          <div
                            class="d-inline-block color-indicator"
                            [style.background-color]="c.color"
                          ></div>
                        }
                      }
                    </div>

                    <div class="text-center fs-12">
                      {{ c.title | translate }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</ion-content>

<ion-footer>
  <div class="p-3">
    <div class="row">
      <div class="col-12 text-center">
        <ion-button
          expand="block"
          fill="outline"
          color="medium"
          (click)="dismissModal()"
        >
          {{ 'selectTimeInterval.cancel' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-footer>
